// src/services/image_services.ts

// Products page images
export const getProductImageByType = (productKey: string): string => {
  const imagePathMap: { [key: string]: string } = {
    windows: "/assets/images/productsPage_images/wind2.webp",
    entrDoors: "/assets/images/productsPage_images/meranti1.webp",
    slidingDoors: "/assets/images/productsPage_images/sliding_door1.webp",
    intDoors: "/assets/images/productsPage_images/int_door2.webp",
    winterGarden: "/assets/images/productsPage_images/wg1.webp",
    accessories: "/assets/images/productsPage_images/stairs1.webp",
  };

  return (
    imagePathMap[productKey] || "/assets/images/productsPage_images/default.jpg"
  );
};

// get accessorie images
export const getAccessoryImages = async (): Promise<{
  [key: string]: string;
}> => {
  try {
    // A kiegészítők képeinek nevei
    const accessoryImageNames = [
      "furniture1.webp",
      "boiserie3.webp",
      "blinds1.webp",
      "shutter1.webp",
      "insect_screen1.webp",
      "stairs2.webp",
      "window_sills1.webp",
      "kilincs2.webp",
    ];

    // Lokális mappa elérési útvonala
    const basePath = "/assets/images/products/accessories/";

    // Képek teljes elérési útvonalának létrehozása
    const images: { [key: string]: string } = {};
    accessoryImageNames.forEach((name) => {
      images[name] = `${basePath}${name}`;
    });

    return images;
  } catch (error) {
    console.error("Error loading accessorie ia:", error);
    return {};
  }
};

// get sliding door images
export const getWgImages = async (): Promise<string[]> => {
  try {
    const imageNames = ["wg1.webp", "wg2.webp", "wint1.webp"];

    const basePath = "/assets/images/products/winter_garden/";

    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading winter garden images:", error);
    return [];
  }
};

export const getWgGalleryImages = async (): Promise<string[]> => {
  try {
    // Gallery image names
    const gridImageNames = [
      "wg_gal1.webp",
      "wg_gal2.webp",
      "wg_gal3.webp",
      "wg_gal7.webp",
      "wg3.webp",
      "wg_gal4.webp",
      "wg_gal5.webp",
      "wg_gal6.webp",
      "wg_gal8.webp",
      "wg_gal9.webp",
      "wg_gall11.webp",
      "wg_gal12.webp",
    ];

    const basePath = "/assets/images/products/winter_garden/gallery/";
    const images = gridImageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading winter garden gallery images:", error);
    return [];
  }
};

// get sliding door images
export const getSlidingDoorsImages = async (): Promise<string[]> => {
  try {
    const imageNames = [
      "sliding_door1.webp",
      "sliding_door2.webp",
      "sliding_door3.webp",
    ];

    const basePath = "/assets/images/products/sliding_doors/";

    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading sliding door images:", error);
    return [];
  }
};

export const getSlidingDoorsGalleryImages = async (): Promise<string[]> => {
  try {
    // Gallery image names
    const gridImageNames = [
      "sl_gall8.webp",
      "sl_gal12.webp",
      "sl_gal13.webp",
      "sl_gal10.webp",
      "sl_gall3.webp",
      "sl_gall4.webp",
      "sl_gall2.webp",
      "sl_gall7.webp",
      "sl_gall5.webp",
      "sl_gall6.webp",
      "sl_gall9.webp",
      "sl_gal11.webp",
      "sl_gall1.webp",
    ];

    const basePath = "/assets/images/products/sliding_doors/gallery/";
    const images = gridImageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading sliding door grid images:", error);
    return [];
  }
};

// get entrance door images
export const getInteriorDoorsImages = async (): Promise<string[]> => {
  try {
    const imageNames = ["int_door1.webp", "int_door2.webp"];

    const basePath = "/assets/images/products/int_doors/";

    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading interior door images:", error);
    return [];
  }
};

export const getInteriorDoorsGridImages = async (): Promise<string[]> => {
  try {
    // Grid képek nevei
    const gridImageNames = [
      "int_grid1.webp",
      "int_grid2.webp",
      "int_grid3.webp",
      "int_desc2.webp",
      "int_door3.webp",
      "int_grid8.webp",
      "int_grid4.webp",
      "int_grid5.webp",
      "int_grid7.webp",
      "int_grid9.webp",
      "int_grid10.webp",
      "int_grid11.webp",
      "int_grid12.webp",
      "int_grid13.webp",
      "int_grid14.webp",
      "int_grid15.webp",
      "int_grid16.webp",
    ];

    const basePath = "/assets/images/products/int_doors/grid/";
    const images = gridImageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading interior door grid images:", error);
    return [];
  }
};

// get entrance door images
export const getEntranceDoorsImages = async (): Promise<string[]> => {
  try {
    // A bejárati ajtókhoz tartozó képek nevei
    const imageNames = ["entr1.webp", "entr2.webp"];

    // Lokális mappa elérési útvonala
    const basePath = "/assets/images/products/ext_doors/";

    // Képek teljes elérési útvonalának létrehozása
    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading entrance door images:", error);
    return [];
  }
};

export const getEntranceDoorsGridImages = async (): Promise<string[]> => {
  try {
    // Grid képek nevei
    const gridImageNames = [
      "entr_grid1.webp",
      "entr_grid2.webp",
      "entr_grid3.webp",
      "oak_entr_door.webp",
      "entr_grid5.webp",
      "entr_grid6.webp",
      "entr_grid8.webp",
      "entr_grid9.webp",
      "entr_grid10.webp",
      "entr_grid11.webp",
      "entr_grid12.webp",
      "entr_grid4.webp",
    ];

    const basePath = "/assets/images/products/ext_doors/grid/";
    const images = gridImageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading entrance door grid images:", error);
    return [];
  }
};

// get wood-alu page images
export const getWoodAluImages = async (): Promise<string[]> => {
  try {
    // A Wooden oldalhoz tartozó képek nevei
    const imageNames = [
      "wood_alu_branzan2.webp",
      "wood_alu_window1.webp",
      "fa_alu_munka.webp",
    ];

    // Lokális mappa elérési útvonala
    const basePath = "/assets/images/products/windows/wood_alu/";

    // Képek teljes elérési útvonalának létrehozása
    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading wood-alu image:", error);
    return [];
  }
};

// get wooden page images
export const getWoodenImages = async (): Promise<string[]> => {
  try {
    // A Wooden oldalhoz tartozó képek nevei
    const imageNames = [
      "white_house.webp",
      "nice_house.webp",
      "wooden_hintz.webp",
      "hist2.webp",
      "hist3.webp",
      "interior_hintz.webp",
    ];

    // Lokális mappa elérési útvonala
    const basePath = "/assets/images/products/windows/wooden/";

    // Képek teljes elérési útvonalának létrehozása
    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading wooden images:", error);
    return [];
  }
};

export const getWoodenGalleryImages = async (): Promise<string[]> => {
  try {
    // Galéria képek nevei
    const galleryImageNames = [
      "wood_gal.webp",
      "wood_gal9.webp",
      "wood1.webp",
      "wood2.webp",
      "a3.webp",
      "b1.webp",
      "parv3.webp",
      "wood_gal2.webp",
      "wood_gal3.webp",
      "wood_gal4.webp",
      "wood_gal5.webp",
      "wood_gal6.webp",
      "wood_gal7.webp",
      "wood_gal8.webp",
      "wood_gal10.webp",
      "wood_gal11.webp",
      "wood_gal13.webp",
      "wood_gal14.webp",
      "wood_gal17.webp",
    ];

    const basePath = "/assets/images/products/windows/wooden/gallery/";
    const images = galleryImageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading wooden gallery image:", error);
    return [];
  }
};

//get windows page images
export const getWindowsImages = async (): Promise<string[]> => {
  try {
    // Az összes Windows oldalhoz tartozó kép neve
    const imageNames = [
      "window_tekt_int1.webp",
      "interior_karitas.webp",
      "type_wood.webp",
      "type_wood_alu.webp",
      "type_passive.webp",
    ];

    // A képek elérési útvonala a lokális assets mappában
    const basePath = "/assets/images/products/windows/";

    // Képek teljes elérési útvonalának létrehozása
    const images = imageNames.map((name) => `${basePath}${name}`);

    return images;
  } catch (error) {
    console.error("Error loading Windows image:", error);
    return [];
  }
};

//portfolio images
export const getPortfolioProjectsImages = async (
  projectFolder: string
): Promise<string[]> => {
  try {
    const response = await fetch(
      "/assets/images/portfolio/portfolio_projects/portfolio_image_data.json"
    );
    const imageData = await response.json();

    if (!imageData[projectFolder]) {
      console.warn(`Nincs kép a következő projekthez: ${projectFolder}`);
      return [];
    }

    return imageData[projectFolder].map(
      (imageName: string) =>
        `/assets/images/portfolio/portfolio_projects/${projectFolder}/${imageName}`
    );
  } catch (error) {
    console.error("Error loading portfolio images:", error);
    return [];
  }
};
